module.exports = __webpack_public_path__ + "public/images/kakaotalk.af285fef5122c1555c8525dddf8cc41d.svg";